import axios from "axios";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { root_url } from "../setting";
// import { useLocation } from 'react-router-dom';

const Agree = ({ setNowProcess, setTicketInfo, ticketType }) => {
  //두 항목에 동의했는지를 관리하는 state
  const [isAgree, setIsAgree] = useState([false, false]);
  //서버에서 티켓정보를 가져왔는지 체크하는 state
  const [isGetTicketInfo, setIsGetTicketInfo] = useState(false);
  // const { pathname } = useLocation();

  const onClickAgree = (num) => {
    let new_array = [...isAgree];
    new_array[num] = !new_array[num];
    setIsAgree(new_array);
  };
  const onClickAllAgree = () => {
    const new_array = [true, true];
    setIsAgree(new_array);
  };
  const onClickNext = (e) => {
    e.preventDefault();
    //동의하기를 누르면 서버에서 ticket정보를 받아오고, 모든 티켓의 open_time~close_time에 해당하지 않거나,
    //선택가능한 티켓이 없는 경우(모두 품절),
    //적절한 알람으로 사용자를 유도한다.
    console.log(isGetTicketInfo);
    if (isAgree[0] === true && isAgree[1] === true) {
      axios({
        method: "get",
        url: `${root_url}/api/join/ticket-info`,
      })
        .then((res) => {
          if (res.status === 200) {
            let { data } = res;
            console.log(data);
            // const ticketType = pathname.split('/')[2];
            // console.log('ticketType: ' + ticketType);
            setTicketInfo(
              data.filter((ticket) => ticket.ticketType === ticketType)
            );
            data = data.filter((ticket) => ticket.ticketType === ticketType);

            // const new_array = data.filter(
            //   (ticket) => ticket.ticketType === ticketType
            // );
            // console.log(new_array);
            /*  ---data[0]---
            acceptable: 1000
            choiceOption: "XXL,XL,L,M,S,XS"
            closeTime: "2021-10-17T08:50:00.000Z"
            createTime: "2021-06-21T23:08:23"
            displayOrder: 0
            distance: 10
            eventKey: "DCM21"
            openTime: "2021-10-17T07:30:00.000Z"
            saleClose: "2021-09-17"
            saleOpen: "2021-08-02"
            souvenir: "티셔츠"
            ticketName: "오프라인 10Km-A조"
            ticketPrice: 20000
            ticketSeq: 1
            total: 6
            trace: false
            updateTime: "2021-06-21T23:08:22"
            */
            setIsGetTicketInfo(true);
            let isAcceptable = false;
            let isTimeOk = false;
            let now = new Date();
            // console.log(now.getTime());
            // console.log(new Date(data[0].saleOpen).getTime());
            for (let i in data) {
              console.log(data[i]);
              // console.log(
              //   i +
              //     ') open time : ' +
              //     (new Date(data[i].saleOpen).getTime() <= now.getTime())
              // );
              // console.log(
              //   i +
              //     ') close time : ' +
              //     (now.getTime() <= new Date(data[i].saleClose).getTime())
              // );
              // console.log(
              //   i + ') acceptable : ' + (data[i].acceptable > data[i].total)
              // );
              if (data[i].acceptable > data[i].total) {
                isAcceptable = true;
                if (isTimeOk) {
                  break;
                }
              }
              if (
                data[i].saleOpenTime === null &&
                data[i].saleCloseTime !== null
              ) {
                //오픈시간이 없는경우, 현재시간과 saleClose만 보면됨
                if (
                  now.getTime() <= new Date(data[i].saleCloseTime).getTime()
                ) {
                  console.log("오픈시간이 지정되지 않음");
                  isTimeOk = true;
                  if (isAcceptable) {
                    break;
                  }
                }
              } else if (
                data[i].saleCloseTime === null &&
                data[i].saleOpenTime !== null
              ) {
                //종료시간이 없는경우, 현재시간과 saleOpen만 보면됨
                if (new Date(data[i].saleOpenTime).getTime() <= now.getTime()) {
                  console.log("종료시간이 지정되지 않음");
                  isTimeOk = true;
                  if (isAcceptable) {
                    break;
                  }
                }
              } else if (
                data[i].saleCloseTime === null &&
                data[i].saleOpenTime === null
              ) {
                console.log("오픈시간과 종료시간이 지정되지 않음");
                isTimeOk = true;
                if (isAcceptable) {
                  break;
                }
              } else {
                if (
                  new Date(data[i].saleOpenTime).getTime() <= now.getTime() &&
                  now.getTime() <= new Date(data[i].saleCloseTime).getTime()
                ) {
                  console.log("오픈시간과 종료시간이 지정됨");
                  isTimeOk = true;
                  if (isAcceptable) {
                    break;
                  }
                }
              }
            }
            console.log(isTimeOk);
            //1. 모든 티켓이 품절인 경우(tb_ticket::acceptable~total)
            if (!isAcceptable) {
              alert("모든 종목이 품절입니다. ");
            }
            //2. 모든 티켓의 open_time과 close_time이 아닌 경우
            else if (!isTimeOk) {
              let eventStartDate = new Date(data[0].saleOpenTime);
              let eventEndDate = new Date(data[0].saleCloseTime);
              // 오픈 시작일 지나지 않은 경우
              if (now.getTime() < eventStartDate.getTime()) {
                alert(
                  `접수기간은 ${eventStartDate.getMonth() + 1}월 ${eventStartDate.getDate()}일부터 ${eventEndDate.getMonth() + 1}월 ${eventEndDate.getDate()}일까지입니다.`
                );
              } 
              // 판매 마감일 지난 경우
              else if (now.getTime() > eventEndDate.getTime()) {
                alert("대회 참가 신청이 마감되었습니다.");
              }
            } else {
              setNowProcess(2);
            }
          }
        })
        .catch((e) => {
          //서버 통신 원활하지 않은 경우
          console.log(e);
          alert(
            "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
          );
          return;
        });
    } else {
      //동의하지 않은 항목이 있는 경우
      alert("모두 동의해야 합니다.");
    }

    console.log(isGetTicketInfo);
  };

  return (
    <div>
      <Container className="mt-3">
        <h3 className="text-custom-color mt-4 mb-4">약관 동의</h3>
        <div className="mt-3 mb-2">
          <Row>
            <Col className="mb-4">
              <h3>
                참가자 유의사항 및 동의 서약서
                <span style={{ fontSize: "1.2rem" }}>(필수)</span>
              </h3>
            </Col>
          </Row>
          <Container
            className="border p-3"
            style={{ height: "15rem", overflowY: "scroll" }}
          >
            <p>
              1. 본 대회의 모든 사항은 제24회 대청호마라톤대회 홈페이지에서 볼
              수 있습니다.
              <br />
              <br />
              2. 제한시간 이후에는 반드시 진행요원의 지시에 따라 회수 차량에
              탑승하셔야 합니다. 탑승 거부로 인해 발생하는 사고에 대해서는
              대회중 의 사고로 인정되지 않으니 안전요원의 지시에 꼭 따라주시기
              바랍니다.
              <br />
              <br />
              3. 최근 각종 마라톤대회에서 부상은 물론,사망자가 속출하고
              있습니다. 참가자는 반드시 본인의 건강상태를 고려하여 참가신청을
              하시기 바랍니다. 추최측은 경기 중 발생한 부상, 사고 등에 대해
              응급조치와 더불어 보험 적용 한도 내에서 치료비를 부담합니다.
              <br />
              <br />
              4. 감염병 또는 자연재해 등 특별한 사정으로 동시 출발이 어려울 경우
              출발 시간을 달리 할 수 있으며, 이때 필요한 사항은 별도로
              공지합니다.
              <br />
              <br />
              5. 참가자를 위해 주최자배상책임보험에 가입되어 있지만,
              주최자배상책임보험 외에는 주최측에서 책임을 지지 않으므로 참가자
              본인이 의료기관을 통해 무리 없이 달릴 수 있는 지의 여부를 스스로
              결정한 뒤 참가신청 해주시기 바라며, 대회도중 이상이 느껴질 경우
              즉시 경기를 중단하고 의료 팀 및 운영요원에게 도움을 요청하시기
              바랍니다.
              <br />
              <br />
              6. 칩을 부착하지 않거나 골인점등에 설치된 매트를 밟지 않을 경우
              기록이 측정되지 않습니다. 기록이 측정되지 않으면 실격 처리 되며,
              기록증도 발급되지 않습니다. 또한 타인의 칩을 달고 뛰는 등
              대회기록의 정확한 사정(査定)을 방해하거나 곤란하게 하는 일체의
              부정행위와 이에 관여한 참가자에 대하여는 그 기록을 인정하지
              않으며, 대회 당일 번호표를 부착하지 않거나 변조된 것을 부착할
              경우도 대회운영요원에 의해 참가가 제지됨을 유념해 주시기 바랍니다.
              <br />
              <br />
              7. 참가신청 마감 후에는 참가비를 환불하지 않으며 참가가 확정이 된
              뒤에는 참가자격 양도 및 대리참가가 절대 불가능합니다.
              <br />
              <br />
              8. 마라톤사무국은 신청자의 보다 나은 서비스 제공을 위해 개인정보를
              협찬사 및 협력사와 공유할 수 있습니다. 그 외 다른 영리적인
              목적으로 개인정보를 타인 또는 타기업, 기관에 공개하지 않습니다.
              다만 신청자가 참가자유의사항 및 이용약관을 위배한 사람인 경우,
              타인에게 법적인 피해를 주는 경우, 혹은 미풍양속을 해치는 행위를 한
              경우 등은 법적인 조치를 취하기 위해 개인정보를 공개할 수 있습니다.
              <br />
              <br />
            </p>
          </Container>
          <Row className="m-2 mb-5 mt-4">
            <Col
              style={{ cursor: "pointer" }}
              onClick={() => onClickAgree(0)}
              className={`col ${isAgree[0] ? "text-custom-color" : "text-secondary"
                }`}
            >
              동의하기 <i className="far fa-check-circle"></i>
            </Col>
          </Row>
        </div>
        <div className="mb-3 mt-3">
          <Row>
            <Col className="mb-4">
              <h3>
                홈페이지 개인정보 수집 동의 서약서
                <span style={{ fontSize: "1.2rem" }}>(필수)</span>
              </h3>
            </Col>
          </Row>
          <Container
            className="border p-3"
            style={{ height: "15rem", overflowY: "scroll" }}
          >
            <p>
              대청호마라톤대회는 개인정보보호 관계 법령에 따라 아래와 같이
              수집항목 및 이용목적에 관해 알리오니, 동의하여 주시기 바랍니다.
              <br />
              <br />
              [수집/이용 항목]
              <br />
              (필수항목) 이름, 생년월일, 성별, 주소, 연락처, 참가종목
              <br />
              (선택항목) 이메일, 기념품
              <br />
              <br />
              [수집/이용 목적]
              <br />
              서비스 제공을 위한 본인확인 및 관련 이벤트 진행, SMS발송 등으로
              이용되며, 수집한 개인정보는 본 수집/이용 목적이외의 다른 용도로
              사용되지 않습니다.
              <br />
              <br />
              [이용 및 보유 기간]
              <br />
              수집된 개인정보는 차기 대회 안내 및 홍보 그리고 기록자료 조회를
              위하여 마라톤사무국에서 보유하며, 본 대회홍보 외 어떠한 곳에도
              제공되지 않습니다.
              <br />
              (단, 기타 법령에 따로 정하는 경우에는 해당 기간까지 보관)
              <br />
              <br />
              [동의거부 권리 및 불이익]
              <br />
              필수항목을 입력하지 않은 경우 대청호마라톤대회에 참여하실 수
              없습니다.
              <br />
            </p>
          </Container>
          <Row className="m-2 mb-5 mt-4">
            <Col
              style={{ cursor: "pointer" }}
              onClick={() => onClickAgree(1)}
              className={`${isAgree[1] ? "text-custom-color" : "text-secondary"
                }`}
            >
              동의하기 <i className="far fa-check-circle"></i>
            </Col>
          </Row>
          <br />
          <Row>
            <Col
              style={{ cursor: "pointer" }}
              onClick={onClickAllAgree}
              className={`text-center mb-5 ${isAgree[0] && isAgree[1]
                ? "text-custom-color"
                : "text-secondary"
                }`}
            >
              모든 약관에 동의합니다 <i className="far fa-check-circle"></i>
            </Col>
          </Row>
        </div>
      </Container>
      <Row className="mt-5 mb-5 pb-5">
        <Col
          xs={{ span: "4", offset: "1" }}
          md={{ span: "3", offset: "2" }}
          className="p-1 border rounded-pill bg-custom-grey text-center cursor-pointer"
          onClick={() => alert("동의하지 않으면 대회 신청이 불가합니다.")}
        >
          비동의
        </Col>
        <Col
          xs={{ span: "4", offset: "2" }}
          md={{ span: "3", offset: "2" }}
          className="p-1 border rounded-pill bg-custom-color text-center text-white cursor-pointer"
          onClick={onClickNext}
        >
          동의하고 진행
        </Col>
      </Row>
    </div>
  );
};

export default Agree;
